import { getSubAccountList, querySubAccountBalance } from '@/api/domain/finance'
import { operateMaxShowLength } from '@/store/dict/config'
import { convertNumber } from '@/utils'
import { serviceState } from '../selectOptions'

export default {
  computed: {
    configData() {
      // 基础列配置
      const baseColumns = [
        {
          name: 'accountId',
          columnProps: {
            prop: 'accountId',
            label: '资金收款户ID',
            minWidth: 150,
          },
        },
        {
          name: 'merchantName',
          columnProps: {
            label: '资金收款户公司主体全称',
            prop: 'merchantName',
            minWidth: 180,
          },
        },
        {
          name: 'bankCardNo',
          columnProps: {
            prop: 'bankCardNo',
            label: '提现银行卡卡号',
            minWidth: 120,
          },
          render: ({ row }) => {
            if (row.bankCardNo) {
              return (<span> {row.bankCardNo } </span>)
            } else {
              return (<span style="color: red;">未绑卡</span>)
            }
          },
        },
        {
          name: 'bankShortName',
          columnProps: {
            prop: 'bankShortName',
            label: '开户行',
            minWidth: 150,
          },
          render: ({ row }) => {
            if (row.bankShortName) {
              return (<span> {row.bankShortName } </span>)
            } else {
              return (<span style="color: red;">未绑卡</span>)
            }
          },
        },
        {
          name: 'accountBalance',
          columnProps: {
            prop: 'accountBalance',
            label: '账户余额',
            minWidth: 150,
          },
          render: ({ row }) => {
            if (row.accountBalance.availableAmount !== null) {
              return this.$createElement('span', {}, `${convertNumber(row.accountBalance.availableAmount)}元`)
            }
            return this.$createElement('el-button', {
              props: {
                type: 'text',
                loading: Boolean(row.accountBalance.loading),
              },
              on: {
                click: async () => {
                  row.accountBalance.loading = true

                  try {
                    const { code, data } = await querySubAccountBalance({
                      accountId: row.accountId,
                      channelType: this.bankChannelType,
                    })

                    if (code === 1) {
                      row.accountBalance.loading = false
                      row.accountBalance.availableAmount = data.availableAmount
                      row.accountBalance.frozenAmount = data.frozenAmount
                    } else {
                      row.accountBalance.loading = false
                    }
                  } catch (error) {
                    row.accountBalance.loading = false
                  }
                },
              },
            }, '点击查询余额')
          },
        },
        {
          name: 'relationCompanys',
          columnProps: {
            prop: 'relationCompanys',
            label: '合作网约平台',
            width: 200,
          },
          render: ({ row }) => {
            if (!row.spOrg || row.spOrg.length === 0) return (<span> -- </span>)

            const spOrgList = []

            for (let i = 0; i < row.spOrg.length; i++) {
              const org = row.spOrg[i]
              const { orgName, orgId } = org

              const orgElement = this.$createElement('div', { style: 'margin-bottom: 5px' }, [
                this.$createElement('div', { style: 'font-weight: bold' }, `${orgName} ${orgId}`),
              ])
              spOrgList.push(orgElement)
            }

            return this.$createElement('div', {}, spOrgList)
          },
        },
      ]

      // 网商银行特有的支付宝相关列
      const alipayColumns = [
        {
          name: 'alipayThirdAccountNo',
          columnProps: {
            prop: 'alipayThirdAccountNo',
            label: '企业支付宝账户',
            minWidth: 150,
          },
          render: ({ row }) => {
            return (<span>{row.alipayThirdAccountNo || '--'}</span>)
          },
        },
        {
          name: 'alipayOpenState',
          columnProps: {
            prop: 'alipayOpenState',
            label: '支付宝支付开通状态',
            minWidth: 150,
          },
          render: ({ row }) => {
            const statusMap = {
              1: '未开通',
              2: '开通中',
              3: '已开通',
              4: '开通失败',
              5: '待确认',
            }
            return (<span>{statusMap[row.alipayOpenState] || '--'}</span>)
          },
        },
        {
          name: 'alipayAccountState',
          columnProps: {
            prop: 'alipayAccountState',
            label: '支付宝支付启用状态',
            minWidth: 150,
          },
          render: ({ row }) => {
            const statusMap = {
              0: '禁用',
              1: '启用',
            }
            return (<span>{statusMap[row.alipayAccountState] || '--'}</span>)
          },
        },
      ]

      // 状态和操作列
      const endColumns = [
        {
          name: 'state',
          columnProps: {
            prop: 'state',
            label: '启用状态',
          },
          render: ({ row }) => {
            const state = serviceState[row.state]
            return (<span>{ state }</span>)
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          type: 'operate',
          maxShowLength: operateMaxShowLength,
          getOperateList: ({ row }) => {
            const result = []
            if (this.checkBankChannelPermission('bindBankCardNew', 'bindBankCardNewWangshang', this.bankChannelType) && !row.bankCardNo && this.bankChannelType !== 8) {
              result.push({ name: 'bankCardState', label: '绑定银行卡', action: () => this.bankCardState(row, row.bankCardNo ? 'change' : 'bind') })
            }

            // 网商银行绑定银行卡弹窗
            if (this.judgePermission('bindBankCardNewWangshang') && this.bankChannelType === 8) {
              result.push({ name: 'bindCard', label: row.bankCardNo ? '更换银行卡' : '绑卡', action: () => this.bindCard(row, row.bankCardNo ? 'change' : 'bind') })
            }

            if (this.checkBankChannelPermission('replaceBankCardNew', 'replaceBankCardNewWangshang', this.bankChannelType) && row.bankCardNo && this.bankChannelType !== 8) {
              result.push({ name: 'bankCardState', label: '更换银行卡', action: () => this.bankCardState(row, row.bankCardNo ? 'change' : 'bind') })
            }
            if (this.checkBankChannelPermission('startWithholdingConfigNew', 'startWithholdingConfigNewWangshang', this.bankChannelType) && row.state === 0) {
              result.push({ name: 'handleState', label: '启用', action: () => this.handleState(row, row.state === 0 ? 'open' : 'close') })
            }
            if (this.checkBankChannelPermission('stopWithholdingConfigNew', 'stopWithholdingConfigNewWangshang', this.bankChannelType) && row.state === 1) {
              result.push({ name: 'handleState', label: '停用', action: () => this.handleState(row, row.state === 0 ? 'open' : 'close') })
            }
            if (this.checkBankChannelPermission('withdrawBalance', 'withdrawBalanceWangshang', this.bankChannelType) && row.bankCardNo) {
              result.push({ name: 'withdrawBalance', label: '全部提现', action: () => this.withDrawBalance(row) })
            }

            // 网商银行的支付宝支付申请开通按钮, 1: 未开通, 4: 开通失败, null: 初始化状态
            if (this.bankChannelType === 8 && [1, 4, null].includes(row.alipayOpenState)) {
              result.push({ name: 'openAlipayWithhold', label: '申请开通支付宝支付', action: () => this.openAlipayWithhold(row) })
            }

            return result
          },
        },
      ]

      // 根据银行类型动态组合列配置
      let columns = [...baseColumns]

      // 如果是网商银行（type=8），在合作网约平台后面插入支付宝相关列
      if (this.bankChannelType === 8) {
        columns = [...baseColumns, ...alipayColumns, ...endColumns]
      } else {
        columns = [...baseColumns, ...endColumns]
      }

      return {
        formData: {
          list: [
            {
              el: 'input',
              itemConfig: {
                label: '资金收款户ID',
                prop: 'accountId',
              },
              elConfig: {
                maxLength: 20,
                events: {
                  input: this.accountIdEvents,
                },
              },
            },
            {
              el: 'input',
              itemConfig: {
                label: '资金收款户公司主体全称',
                prop: 'merchantName',
              },
              elConfig: {
                maxLength: 100,
                events: {
                  input: this.merchantNameEvents,
                },
              },
            },
          ],
          formProps: {
            model: {
              channelType: '',
            },
          },
        },
        tableData: {
          columns,
          defaultParams: {
            type: 1, // 代扣收款户配置type为1
          },
          apiFn: getSubAccountList,
          customUseData: (data) => {
            data.items?.forEach((item) => {
              item.accountBalance = {
                loading: false,
                availableAmount: null,
                frozenAmount: null,
              }
            })
          },
        },
        isShowDepartment: false,
      }
    },
  },
  methods: {
    accountIdEvents(value) {
      // 仅支持输入数字
      value = value.replace(/\D/g, '')
      this.$set(this.configData.formData.formProps.model, 'accountId', value)
    },
    merchantNameEvents(value) {
      // 仅支持输入数字、汉字、字母
      value = value.replace(/[^\u4E00-\u9FA5A-Za-z0-9\u0021-\u002F\u003A-\u007E（），。？！]/g, '')
      // 最多允许100个字符
      value = value.substr(0, 100)
      this.$set(this.configData.formData.formProps.model, 'merchantName', value)
    },
  },
}

export const limitMoreZero = (value, callback) => {
  const numberRegex = /^\d+$/ // 正则表达式匹配数字
  if (!numberRegex.test(value)) {
    // 如果输入的值不是数字，将其替换为空字符串
    callback(value.replace(/\D/g, ''))
  }
}

